var _style, _title, _path, _path2, _polygon, _polygon2, _path3, _path4, _path5, _ellipse, _path6, _path7, _path8, _path9, _path0, _polygon3, _polygon4, _path1, _polygon5, _polygon6, _polygon7, _path10, _polygon8, _polygon9, _polygon0, _path11, _polygon1, _g, _g2, _path12, _path13, _polygon10, _polygon11, _path14, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _path15, _path16, _path17, _path18, _path19, _path20, _ellipse0, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _ellipse1, _ellipse10, _ellipse11, _path28, _ellipse12, _ellipse13, _ellipse14, _path29, _polygon12, _polygon13, _path30, _polygon14, _path31, _g3, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 410.1 500",
    style: {
      enableBackground: "new 0 0 410.1 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.4;fill:#D6D8E5;enable-background:new    ;}\n\t.st1{fill:#B1B4C4;}\n\t.st2{fill:#616E84;}\n\t.st3{fill:#20232D;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#2B303F;}\n\t.st6{opacity:0.1;fill:#FFFFFF;enable-background:new    ;}\n\t.st7{fill:#757B89;}\n\t.st8{fill:#E9EAF2;}\n\t.st9{fill:#D9DAE2;}\n\t.st10{fill:#38226D;}\n\t.st11{fill:#9C73FF;}\n\t.st12{fill:#8C50FF;}\n\t.st13{fill:#FFCEA9;}\n\t.st14{fill:#F4F4F4;}\n\t.st15{fill:#3A2C6D;}\n\t.st16{fill:#EDEDED;}\n\t.st17{fill:#2B2A30;}\n\t.st18{fill:#BF4B4B;}\n\t.st19{fill:#E26161;}\n\t.st20{opacity:0.5;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st21{fill:#FF7B7B;}\n\t.st22{fill:#E26D6D;}\n\t.st23{opacity:0.2;enable-background:new    ;}\n\t.st24{fill:#DD990E;}\n\t.st25{fill:#F9CB07;}\n\t.st26{fill:#CC8B09;}\n\t.st27{fill:#4399FF;}\n\t.st28{fill:#70B6FC;}\n\t.st29{fill:#EFBD9C;}\n")), /*#__PURE__*/React.createElement("g", null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Chat_SVG")), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.9,412.2l-87.8-50.6c-1.6-0.9-2.1-2.9-1.2-4.4c0.3-0.5,0.8-1,1.3-1.2l11.1-5.7c1-0.5,2.1-0.5,3.1,0.1 l90.8,52.3c1.6,0.9,2.1,2.9,1.2,4.4c-0.3,0.5-0.8,1-1.3,1.3l-8,4.1C252.1,413.9,248.7,413.8,245.9,412.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.2,402.7l-74.8-43.2c-6.3-3.7-11.4-13.5-11.4-21.9V128.8c0-8.4,5.1-12.3,11.5-8.7l74.8,43.2 c6.3,3.7,11.5,13.5,11.5,21.9V394C262.7,402.5,257.6,406.3,251.2,402.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "252.5,406.4 258.5,403.4 252.8,393.7  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "163.8,122.2 169.2,119.4 168.1,127.4  "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M246.5,405.1l-74.8-43.2c-6.3-3.7-11.5-13.5-11.5-21.9V131.2c0-8.4,5.1-12.3,11.5-8.7l74.8,43.2 c6.3,3.7,11.5,13.5,11.5,21.9v208.7C258,404.8,252.8,408.7,246.5,405.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M257.2,188.2v208.7c0,8.5-5.1,12.3-11.5,8.7l-29.4-16.9l-9.1-5.3l-36.4-21c-6.3-3.7-11.5-13.5-11.5-21.9 V131.8c0-8.5,5.1-12.3,11.5-8.7l74.8,43.2C252,169.9,257.2,179.7,257.2,188.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.8,186.1v203.3c0,5.1-3.6,7.2-8,4.6l-23.4-13.5l-2.1-1.2l-0.7-0.4l-5.1-2.9l-14.6-8.4l0,0l-6.1-3.5 l-2.4-1.4l-16.6-9.6c-4.4-2.6-8-8.8-8-13.9V135.9c0-5.1,3.6-7.2,8-4.6l29.2,16.9v0.1c0.2,4.4,2.6,8.4,6.3,10.8 c3.5,2,6.3,0.4,6.3-3.6c0,0,0-0.1,0-0.1l29.2,16.9C248.2,174.7,251.8,181,251.8,186.1z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.867 -0.4983 0.4983 0.867 -49.2318 124.7566)",
    className: "st5",
    cx: 209.1,
    cy: 154.6,
    rx: 1.9,
    ry: 3.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M208.3,155.1c-0.6-0.4-1-1-1-1.7c0-0.6,0.4-0.9,1-0.6c0.6,0.4,1,1,1,1.7 C209.3,155.2,208.8,155.5,208.3,155.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M260.2,215.7L260.2,215.7c-0.6,0.4-1.1,0-1.1-0.8v-8.9c0-0.8,0.4-1.6,1.1-2.1l0,0c0.6-0.4,1.1,0,1.1,0.8v8.9 C261.3,214.4,260.9,215.2,260.2,215.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M260.2,230.2L260.2,230.2c-0.6,0.4-1.1,0-1.1-0.8v-8.9c0-0.8,0.4-1.6,1.1-2.1l0,0c0.6-0.4,1.1,0,1.1,0.8v8.9 C261.3,229,260.9,229.8,260.2,230.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M237.7,207.5l-60.8-35.1c-1.9-1.4-3.1-3.6-3.1-5.9v-16.7c0-2.3,1.4-3.3,3.1-2.3l60.8,35.1 c1.9,1.4,3.1,3.6,3.1,5.9v16.7C240.8,207.5,239.4,208.5,237.7,207.5z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M221.2,283.3l-44.3-25.6c-1.9-1.4-3.1-3.6-3.1-5.9v-8.7c0-2.3,1.4-3.3,3.1-2.3l44.3,25.6 c1.9,1.4,3.1,3.6,3.1,5.9v8.7C224.3,283.3,222.9,284.3,221.2,283.3z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "173.8,249.8 173.8,265.2 182.4,260.6  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "217.7,275.7 183.1,255.7 183.1,251 217.7,270.9  "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M198.4,231.4l39.3,22.7c1.7,1,3.1-0.1,3.1-2.3V235c0-2.3-1.2-4.5-3.1-5.9l-39.3-22.7c-1.7-1-3.1,0.1-3.1,2.3 v16.7C195.3,227.9,196.5,230.1,198.4,231.4z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "240.8,249.9 240.8,265.4 232.2,250.9  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "203.4,220.6 229.4,235.6 229.4,230.9 203.4,215.9  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "203.4,227.8 217.3,235.8 217.3,231.1 203.4,223  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M176.9,307.6l60.4,34.9c1.7,1,3.1-0.1,3.1-2.3v-16.7c0-2.3-1.2-4.5-3.1-5.9l-60.4-34.9 c-1.7-1-3.1,0.1-3.1,2.3v16.7C173.8,304.1,175,306.3,176.9,307.6z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "240.4,338.3 240.4,353.8 231.8,339.3  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "183.1,297.5 225.8,322.2 225.8,317.4 183.1,292.8  "
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "183.1,304.6 222.9,327.6 222.9,322.9 183.1,299.9  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M237.7,379l-60.8-35.1c-2.1-1.4-3.5-3.7-3.6-6.2v-8.3c0-2.3,1.6-3.2,3.6-2.1l60.8,35.1 c2.1,1.4,3.5,3.7,3.6,6.2v8.3C241.3,379.2,239.6,380.1,237.7,379z M176.9,328.4c-1.4-0.8-2.6-0.2-2.6,1.5v8.3 c0.1,1.8,1.1,3.5,2.6,4.5l60.8,35.1c1.4,0.8,2.6,0.2,2.6-1.5V368c-0.1-1.8-1.1-3.5-2.6-4.5L176.9,328.4z"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "179.3,341.1 178.3,340.5 178.3,332.6 179.3,333.2  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Men_8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 362,
    cy: 291.1,
    rx: 34.6,
    ry: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M381,286c-2.4,2-6,0.2-6.1,0.4c-2.8,2.6-5.8,5.1-8.9,7.4c-1.5,1.2-3.8,2.8-3.4,5c0.8,4.1,7.3,2.8,9.7,1.6 s4.5-3.3,6.8-4.7c1.7-1,3.3-1.6,3.5-3.6C382.8,290.7,381.5,285.9,381,286z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M382.6,291.1c-0.3,2-1.9,2.5-3.6,3.6c-2.4,1.5-4.4,3.6-6.9,4.8c-2.3,1.1-7.9,2.3-9.5-0.6 c0.9,3.9,7.2,2.7,9.7,1.5s4.5-3.3,6.8-4.7c1.7-1,3.3-1.6,3.5-3.6C382.6,291.7,382.6,291.4,382.6,291.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M360.1,278.2c-2.4,2-6.6-0.2-6.8,0c-2.5,2.5-5.2,4.9-8,7.2c-1.5,1.2-3.8,2.8-3.4,5 c0.8,4.1,7.2,2.8,9.7,1.6s4.5-3.3,6.8-4.7c1.6-1,3.3-1.6,3.5-3.6C362.1,282.3,360.5,278.2,360.1,278.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M361.9,283c-0.3,2-1.9,2.5-3.6,3.6c-2.4,1.5-4.4,3.6-6.9,4.8c-2.3,1.1-7.9,2.3-9.5-0.6 c0.9,3.9,7.2,2.7,9.7,1.5s4.5-3.3,6.8-4.7c1.6-1,3.3-1.6,3.5-3.6C362,283.6,361.9,283.3,361.9,283z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_",
    className: "st12",
    d: "M381.1,197c-0.1,3.6-1.2,19.5-1.8,27.8s-0.6,18.6-0.6,18.6s1.5,6.1,2.4,13.3 c0.9,7.2,0,29.8,0,29.8c-1.9,1.2-4.3,1.2-6.2,0c0,0-3.9-18.1-5.6-26.3s-2.1-12.9-3-17.9c-1.1-6.1-3.5-34.7-3.5-34.7l-1,0.1 l-2.6,32.3c0.8,2.4,1.3,4.8,1.6,7.3c0.7,5.2-0.7,31.7-0.7,31.7c-2.1,1.2-4.7,1.1-6.7-0.3c0,0-6.4-35-6.4-40.3 c0-3.5,0.6-50,0.6-50L381.1,197z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2",
    className: "st13",
    d: "M372.4,126.6c0,0-0.4,7.9-0.2,8.7s3.6,3,4.6,3.9s-5.5,7.2-8.6,8.7 s-13.2-2.4-13.4-7.3s1.7-9.1,3.2-9.3S372.4,126.6,372.4,126.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M353.2,133.7c0,0-2.1-3.3-10,15s-12.7,23.1-16.2,27.6c-3.2,4.1-4.8-2.4-4.8-2.4s2.5-3.2,0.4-3.2 c-1.2,0.1-2.8,2.5-2.8,2.5l2.7,4.3l7,3.6c0,0,8.6-7.9,11.3-12.7c3-3.8,7.5-11.4,7.5-11.4L353.2,133.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M319.9,176.9c-0.1-0.1-2.2-2.5-2.2-2.5s-1.2-1.1,0.1-1.2s6.2-0.1,6.2-0.1c0.5,0,1,0.1,1.4,0.4 c0.6,0.5,7.6,9.4,7.6,9.4s0.3,0.5-0.6,0.6s-6.8,0-6.8,0L319.9,176.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M319.3,175.4c0,0-2.1-0.4-1.6,1.6s3.5,4.1,3.5,4.1l3.1,2.6c0.8,0.5,1.8,0.5,2.5,0c0.8-0.5,1.9-1.9,0.7-3.1 s-2.3-4.1-5.5-4c0,0-0.2-0.8-2-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3",
    className: "st14",
    d: "M373.3,136.6c0,0-5.8,8.6-13.8,9.4c-2.5-2.5-2.8-11.4,0.8-14.2c0,0-3.2-2.6-5.4-2.1 c-2.6,1.4-4.6,3.7-5.6,6.5c-1.5,4.5-2.3,9.8-2.2,18.2s0,34.2,0,34.2s1.1,5.4,8.4,9.5s12.6,4.4,17.6,3.3c4.1-0.9,7.4-2.4,8.8-5.3 c-0.4-5.9-3-21.3-2-28.8s2.5-13,3-19s-0.8-5.9-3.8-8C377.2,139,375.3,137.7,373.3,136.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_4",
    className: "st13",
    d: "M376.5,200.5c1.2-1.3,3.3-8.8,4.4-13.5c1.1-5.3,1.4-10.7,0.7-16 c-1.1-6.4-4-15.3-4.8-18.9s0.3-5.2,1.9-6.7c1.9-1.7,4.8-1.2,6.6,3.9c2.4,7.1,4,14.4,4.8,21.8c0.4,5.5-0.1,11.1-1.4,16.4 c-1.2,5-3,8.6-5.3,13.2c-0.6,1.2-2.1,4.7-3,7.2S375.4,201.7,376.5,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    className: "st13",
    d: "M354.4,114.8L354.4,114.8c1-6.2,5.4-10.8,11.8-10.5c6.7,0.4,11.9,6.1,11.6,12.9 c-0.2,3.8-2.2,7.3-5.3,9.5c-0.2,0.9-0.6,1.8-1,2.7c-2.2,2.6-9,4.3-11,4c-2.5-0.4-3.9-1.4-5.1-4.1 C353.2,124.3,353.9,117.8,354.4,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M372.4,126.6L372.4,126.6l-0.6-5.4c0,0,4.4-11.4-6-9.2c-6.9,1.4-8.6,2.1-10.7-2.5s5.3-8.7,14-7.6 c6.3,0.6,11,6,10.9,12.2C379.7,117.6,378.8,124.4,372.4,126.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M390.1,157.5c0,0-5.7,5.6-12.4,4c-1-0.6-3.3-13.8-3.3-13.8s0-7.3,5.6-7.1S390.1,157.5,390.1,157.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M347,150.1c0,0-3.7,0.5-4.9-1.3c0.2-3,5.1-18.3,12.7-19.1c-1.8,1.7-3.4,3.6-4.7,5.7 C347.4,139.9,347,150.1,347,150.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Men_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 34.6,
    cy: 480,
    rx: 34.6,
    ry: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    className: "st13",
    d: "M9.2,330.5c-0.4,3.4-4.4,17.9-3.5,22.8s14.6,13.3,14.6,13.3l1.9-8.5l-7.6-7.4l2-14.1 L9.2,330.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
    className: "st16",
    d: "M19.8,316.2c-2.8-1.3-6-0.3-7.6,2.3c-2,3.3-4.1,14.8-4.3,16.7c0,0,2.8,3.9,7.1,3.2 L19.8,316.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M35.5,477.9c3,0.8,6.2,0.4,8.9-1.1c2.1,0.1,13.7-4.9,15.3-0.7c1.4,3.6-3.6,7-6.3,7.7 c-5.8,1.4-10.2,4.3-12.5,4.8c-1.8,0.4-4,0.6-5.4-0.8C33.7,486.1,33.8,480,35.5,477.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M40.8,487.5c2.3-0.5,6.7-3.4,12.5-4.8c2.2-0.5,6.1-3,6.5-5.9c0.5,3.4-4,6.3-6.5,7 c-5.8,1.4-10.2,4.3-12.5,4.8c-1.8,0.4-4,0.6-5.4-0.8c-0.4-0.4-0.6-0.9-0.8-1.4C36.4,487.8,38.6,488.2,40.8,487.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M16.7,469.4c3,0.8,6.2,0.4,8.9-1.1c2.1,0.1,13.7-4.9,15.3-0.7c1.4,3.6-3.6,7-6.3,7.7 c-5.9,1.4-10.2,4.3-12.5,4.8c-1.8,0.4-4,0.6-5.4-0.8C14.9,477.7,15,471.6,16.7,469.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M22,479.1c2.4-0.5,6.7-3.4,12.5-4.8c2.2-0.5,6.1-3,6.5-5.9c0.5,3.4-4,6.3-6.5,7 c-5.9,1.4-10.2,4.3-12.5,4.8c-1.8,0.4-4,0.6-5.4-0.8c-0.4-0.4-0.6-0.9-0.8-1.4C17.6,479.3,19.9,479.7,22,479.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
    className: "st19",
    d: "M16.4,437.9c0.5-4.3,1.4-8.6,2.7-12.7c0,0-0.8-11-1.2-21.3 c-0.5-11.8-4.6-22.1-1.3-31.6l36.4,8.1c0,0-2.2,47-2.7,52.7c-0.3,4.4-0.8,8.8-1.6,13.2c-1.7,9.1-4.4,30.8-4.4,30.8 c-3.8,2.2-8.9,1-8.9,1s0.3-27.4,0.5-34c0.3-8,0.5-7.4,0.5-7.4l-1.2-20l-0.8-9.9c0,0-1,7.3-1.7,13.8c-0.6,5.7-2,10.8-3.5,21.4 c-1.3,9.2-3.5,27.6-3.5,27.6c-3.8,2.2-9.1,0.4-9.1,0.4S15.4,445.9,16.4,437.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_9",
    className: "st13",
    d: "M21.7,316.4c2.8,0.1,4.8,0.9,5.2,0c0.3-1.4,0.5-2.9,0.6-4.3 c-0.3-0.8-0.6-1.7-0.6-1.7c-3.5-2.1-4.6-5.9-5-10.3c-0.8-7.5,3.3-14,10.7-14.8c7-0.7,12.2,4.2,13.6,11c0.7,3.4,2.2,9.7,0.2,15.2 c-1.1,3.1-2.6,5.5-4,6c-1.4,0-2.8-0.2-4.2-0.4l0,0c0,0-0.4,2.1-0.6,3.4s-0.2,2,2.5,3.7s-4,5-8.4,4.7s-9.3-3-10.6-5.8 C19.7,320,19.8,316.4,21.7,316.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_10",
    className: "st14",
    d: "M25.7,316.9c-0.8,1.9,1.2,4.3,6.4,5.9s5.7-0.5,5.7-0.5s7.6,3.5,10.1,5.2 c3.1,2.2,4.5,8.5,4.9,19.2c0.5,12.3,0.5,30.6,0.1,33.8c0,0-5.8,5.8-13.3,5.2s-20-7.2-23.1-12.3c0.1-10.8,1.4-12.6-0.4-18.8 c-4-14.3-6.1-20.1-4.2-29.6c1.6-7.8,3.9-8.8,7-8.7C21.3,316.3,23.5,316.5,25.7,316.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11",
    className: "st13",
    d: "M64.6,356.8c-6.1,1.5-7.6-2.3-8.4-5.5c-1.9-7.8-3-14.7-4.5-19.1c-1.7-5.2-3.5-6-6-7 c-3-1.2-5.5,1.3-4.5,7.9c1.2,7.8,2.7,13.3,5.6,22.5c0.8,2.4,2.5,6.7,5,8.8c3.2,2.6,7.9,2.5,15.1,0.7c3.1-0.8,6.4-2.6,12.2-5.3 c1.6-0.7,2.8-1.2,5.8-2.6c3-1.4,5.6-3.4,7.7-6c1.6-2.3,1.3-3.7,1-4.2s-0.6-0.1-1.5,0.8c-1.2,1.6-2.7,3-4.4,4.1c0,0,1.9-2,3-3.3 c0.9-1.2,1.7-2.4,2.3-3.8c0.6-1.3-0.6-3.1-1.5-2.2s-1.3,1.9-2.9,3.8c-0.9,1-1.8,1.9-2.9,2.7c1-1.3,1.9-2.7,2.6-4.2 c1-2-2.3-1-4.3,1c-1.4,1.5-2.6,2.3-2.6,1.9s-2.8,2.5-4.2,4S70.4,355.4,64.6,356.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12",
    className: "st16",
    d: "M43.5,324.1c4.1-0.6,7,1.2,8.8,7.4s3.1,11.3,3.1,11.3c-1.6,2.3-4.1,4-6.8,4.5 c-4.9,1.2-6.7-1.1-6.7-1.1s-1.4-6.5-2.2-10.9S38.4,324.9,43.5,324.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M46,295.4c0,0,6.5-9.8-7.5-11.8c-10.1-1.4-16.6,5-17.3,12.1c-0.7,6.7,3.4,13.7,6.4,16.5 c1.5,0.5,4.6,0.8,8.7-1.1c0.2-1.8,0.2-3.7,0.2-5.5C36.5,305.6,31.5,295.2,46,295.4z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M78.8,349.1c0,0-1.6-2.9-0.6-3.6s2.4,2,2.7,3s-0.1-0.3-0.1-0.3s-1.1-3.3-0.4-3.9s1.7,0.8,2.6,2.8 s0.2-0.2,0.2-0.2s-1.6-3.3-0.9-3.7c0.9-0.6,2.4,1.3,3.3,3.1s-1.2,3.8-1.2,3.8L78.8,349.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mobile"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.9,354.3l-5.9-3.4c-0.5-0.3-0.4-0.8,0.1-1.1l14.3-8.3c0.6-0.3,1.4-0.4,2-0.1l5.9,3.4 c0.5,0.3,0.4,0.8-0.1,1.1l-14.4,8.3C83.2,354.5,82.5,354.6,81.9,354.3z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "75.6,350.4 75.6,349.8 76.2,350  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "98.7,345.3 98.7,344.7 98.2,345.1  "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.9,353.8l-5.9-3.4c-0.5-0.3-0.4-0.8,0.1-1.1l14.3-8.3c0.6-0.4,1.4-0.4,2-0.1l5.9,3.4 c0.5,0.3,0.4,0.8-0.1,1.1l-14.3,8.3C83.3,354.1,82.5,354.1,81.9,353.8z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.867 -0.4983 0.4983 0.867 -165.3697 85.1883)",
    className: "st7",
    cx: 76.9,
    cy: 352.4,
    rx: 0.1,
    ry: 0.1
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -165.2808 85.4907)",
    className: "st7",
    cx: 76.9,
    cy: 351.2,
    rx: 0.1,
    ry: 0.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -165.3309 85.6581)",
    className: "st7",
    cx: 77.2,
    cy: 351.3,
    rx: 0.1,
    ry: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -165.3687 85.8243)",
    className: "st7",
    cx: 77.5,
    cy: 351.5,
    rx: 0.1,
    ry: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -165.7526 87.2411)",
    className: "st7",
    cx: 79.9,
    cy: 352.9,
    rx: 0.1,
    ry: 0.1
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -165.7953 87.4059)",
    className: "st7",
    cx: 80.2,
    cy: 353.1,
    rx: 0.1,
    ry: 0.1
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -165.8418 87.5697)",
    className: "st7",
    cx: 80.5,
    cy: 353.2,
    rx: 0.1,
    ry: 0.1
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -165.8846 87.7345)",
    className: "st7",
    cx: 80.8,
    cy: 353.4,
    rx: 0.1,
    ry: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M79.1,352.5l-0.8-0.5c-0.1,0-0.1-0.1-0.1-0.2l0,0c0-0.1,0-0.1,0.1-0.1l0.8,0.5 C79.1,352.3,79.2,352.4,79.1,352.5L79.1,352.5C79.2,352.5,79.1,352.6,79.1,352.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M96.9,346.6l-0.7,0.4c0,0-0.1,0-0.1-0.1l0,0c0-0.1,0-0.1,0.1-0.2l0.7-0.4c0,0,0.1,0,0.1,0.1l0,0 C97,346.5,96.9,346.5,96.9,346.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M95.8,347.2l-0.7,0.4c0,0-0.1,0-0.1-0.1l0,0c0-0.1,0-0.1,0.1-0.2l0.7-0.4c0,0,0.1,0,0.1,0.1l0,0 C95.8,347.1,95.8,347.2,95.8,347.2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.9,353.7l-5.9-3.4c-0.5-0.3-0.4-0.8,0.1-1.1l14.3-8.3c0.6-0.3,1.4-0.4,2-0.1l5.9,3.4 c0.5,0.3,0.4,0.8-0.1,1.1l-14.3,8.3C83.3,354,82.5,354.1,81.9,353.7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M97.7,344.4l-2.3-1.4l0,0c-0.3,0.2-0.7,0.2-1,0c-0.3-0.2-0.3-0.4,0-0.6l0,0l-2.3-1.3 c-0.4-0.2-0.9-0.2-1.3,0l-14,8.1c-0.3,0.2-0.3,0.5,0,0.7l5.6,3.2c0.4,0.2,0.9,0.2,1.3,0l14-8.1 C98.1,344.9,98.1,344.6,97.7,344.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -1973.4435,
    y1: -2603.0312,
    x2: -1973.4435,
    y2: -2587.7927,
    gradientTransform: "matrix(0.87 0.5 1 -0.58 4387.8496 -164.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M97.7,344.4l-2.3-1.4l0,0c-0.3,0.2-0.7,0.2-1,0c-0.3-0.2-0.3-0.4,0-0.6l0,0l-2.3-1.3 c-0.4-0.2-0.9-0.2-1.3,0l-14,8.1c-0.3,0.2-0.3,0.5,0,0.7l5.6,3.2c0.4,0.2,0.9,0.2,1.3,0l14-8.1 C98.1,344.9,98.1,344.6,97.7,344.4z"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 94.7,
    cy: 342.8,
    rx: 0.3,
    ry: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M94.6,342.9C94.6,342.9,94.6,342.8,94.6,342.9c0-0.1,0.1-0.1,0.2-0.1c0,0,0,0.1,0,0.1 C94.7,342.9,94.7,342.9,94.6,342.9z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M91.1,352.9c0,0,3.1-2.8,3-6.6c-0.2-2.6-1.8-0.7-1.8-0.7l-1.6,2.9c-0.8,1.1-1.8,1.9-3,2.5 c-1.1,0.1-2.2,0.3-3.3,0.5c-1.9,0.4-3.9,2.8-3.9,2.8l2.4,1.9L91.1,352.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M76.6,220.4L18.7,187c-1.1-0.8-2.5-1-3.9-0.6l0,0c-0.2,0.1-0.5,0.2-0.7,0.4l-6.4,3.7l5,5.9v24.1 c0.2,4.2,2.5,8.1,6,10.4l18,11.3l4.9,11.2l-5.2,8.7l7.2-4.1l6.8-7.9l21.7,11.8l1.2,7l7.3-4.2l0.2-0.1H81l0,0 c1.1-0.9,1.7-2.3,1.6-3.8v-30C82.3,226.6,80.1,222.7,76.6,220.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M69.4,224.5l-57.8-33.4c-3.3-1.9-6-0.4-6,3.5v30c0.2,4.2,2.5,8.1,6,10.4l18,11.3l6.9,15.8l6.8-7.9 l26.1,14.1c3.3,1.9,6,0.4,6-3.5v-30C75.2,230.7,72.9,226.8,69.4,224.5z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M404,34.3L346.1,0.8c-1.1-0.8-2.5-1-3.9-0.6l0,0c-0.2,0.1-0.5,0.2-0.7,0.4l-6.5,3.7l5,5.9v24.2 c0.2,4.2,2.5,8.1,6,10.4l18,11.3l4.9,11.2l-5.1,8.8l7.2-4.1l6.8-7.9l21.8,11.8l1.2,7l7.3-4.2l0.2-0.1h0.1l0,0 c1.1-0.9,1.7-2.3,1.6-3.8v-30C409.9,40.5,407.6,36.6,404,34.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M404,34.3L346.1,0.8c-1.1-0.8-2.5-1-3.9-0.6l0,0c-0.2,0.1-0.5,0.2-0.7,0.4l-6.5,3.7l5,5.9v24.2 c0.2,4.2,2.5,8.1,6,10.4l18,11.3l4.9,11.2l-5.1,8.8l7.2-4.1l6.8-7.9l21.8,11.8l1.2,7l7.3-4.2l0.2-0.1h0.1l0,0 c1.1-0.9,1.7-2.3,1.6-3.8v-30C409.9,40.5,407.6,36.6,404,34.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M396.9,38.4L338.9,4.9c-3.3-1.9-6-0.4-6,3.5v30c0.2,4.2,2.5,8.1,6,10.4L357,60.2l6.9,15.9l6.8-7.9 l26.1,14.2c3.3,1.9,6,0.4,6-3.5v-30C402.7,44.6,400.4,40.7,396.9,38.4z"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 30.7991 178.808)",
    className: "st4",
    cx: 349.1,
    cy: 31.9,
    rx: 3.4,
    ry: 5.9
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.867 -0.4983 0.4983 0.867 27.9569 188.8002)",
    className: "st4",
    cx: 367.7,
    cy: 42,
    rx: 3.4,
    ry: 5.9
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 25.4787 198.646)",
    className: "st4",
    cx: 383.4,
    cy: 51.8,
    rx: 3.4,
    ry: 5.9
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M304.5,96.9c0-7-4.9-15.6-11-19.1c-3.2-1.9-6.1-1.9-8.1-0.5l-3.7,2.1l1.6,0.6c-0.5,1.3-0.8,2.8-0.8,4.2 c0,7,4.9,15.6,11,19.1c0.9,0.6,1.9,1,3,1.2v2.2l4.7-2.7l0,0l0,0C303.3,102.8,304.5,100.3,304.5,96.9z"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -7.6453 157.151)",
    className: "st25",
    cx: 289.4,
    cy: 92.8,
    rx: 9,
    ry: 15.6
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -5.5433 154.2574)",
    className: "st26",
    cx: 285.1,
    cy: 87.5,
    rx: 1.3,
    ry: 2.2
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -6.8588 159.1869)",
    className: "st26",
    cx: 293.6,
    cy: 92.4,
    rx: 1.3,
    ry: 2.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M285.1,94.3c0,0,1.4,3.9,4.3,5.6s4.6-0.4,4.6-0.4L285.1,94.3z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "99.9,306.3 106.1,309.9 106.1,293.9 99.9,290.3  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "106.1,293.9 99.9,290.3 105,287.4 111.4,291  "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M129.8,305.3c-0.1-1.5-0.9-2.9-2.2-3.7l-7.3-4.2l1.2-5.5v-0.4c0-0.6-0.1-1.2-0.2-1.7 c-0.2-0.7-1-2.4-1.5-2.1l-7.6,4.4c-0.5,0.1-0.7,0.7-0.7,1.5V307c0.1,1.6,1,3.1,2.3,4l10.4,6c0.9,0.5,1.7,0.3,2.1-0.4l3.5-7.5 c0.1-0.3,0.1-0.6,0.1-0.9V305.3z"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "122.1,319.2 125.8,317 122.4,312.5  "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M126.3,307.4c-0.1-1.5-0.9-2.9-2.2-3.7l-7.3-4.2l1.2-5.5v-0.4c0-0.6-0.1-1.2-0.2-1.7 c-0.2-0.7-1-2.4-1.5-2.1l-7.6,4.4c-0.5,0.1-0.7,0.7-0.7,1.5V309c0.1,1.6,0.9,3.1,2.3,4l10.4,6c0.9,0.5,1.7,0.3,2.1-0.4l3.5-7.5 c0.1-0.3,0.1-0.6,0.1-0.9L126.3,307.4z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M179.9,159.1l0,2.8l0.2,0.1l1.6-1.8l0.7,0.4l-1.8,1.8c0.8,0.6,1.1,1.4,1.3,2.4c0.2,0.7,0.3,1.4,0.5,2.1 l-0.7-0.4c-0.2-0.5-0.3-1.2-0.4-1.7c-0.2-1-0.5-1.7-1.3-2.2l-0.2-0.1l0,2.9l-0.6-0.4l0.1-6.3L179.9,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M186.1,166.7c0,1.7-0.9,1.9-1.7,1.4c-0.9-0.5-1.6-1.9-1.6-3.3c0-1.5,0.8-2,1.7-1.4 C185.4,164,186.1,165.3,186.1,166.7z M183.4,165.2c0,1,0.4,2,1,2.3c0.6,0.3,1-0.1,1-1.2c0-0.8-0.3-1.9-1-2.3 C183.7,163.6,183.4,164.3,183.4,165.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M187.5,165.3l0,1.8l1.6,0.9l0-1.8l0.6,0.4l0,4.5l-0.6-0.4l0-2l-1.6-0.9l0,2l-0.6-0.4l0-4.5L187.5,165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M192.9,168.5l0,0.7l-1.1-0.6l0,3.9l-0.6-0.4l0-3.9l-1.1-0.6l0-0.7L192.9,168.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M195.3,174.4l0-0.6l0,0c-0.2,0.2-0.6,0.3-1,0.1c-0.7-0.4-1-1.3-1-1.9c0-1.1,0.7-1.3,2-0.5l0-0.1 c0-0.4-0.1-1.1-0.8-1.5c-0.3-0.2-0.6-0.2-0.9-0.2l-0.1-0.6c0.3-0.1,0.7,0,1.1,0.3c1,0.6,1.3,1.7,1.3,2.6l0,1.7 c0,0.4,0,0.8,0,1.1L195.3,174.4z M195.2,172.1c-0.7-0.4-1.4-0.7-1.4,0.2c0,0.5,0.3,0.9,0.6,1.1c0.4,0.3,0.7,0,0.8-0.3 c0-0.1,0-0.2,0-0.2L195.2,172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M197.4,171.1l0,2l0.1,0.1l1.3-1.2l0.7,0.4l-1.5,1.2c0.5,0.4,0.9,1.1,1.1,2c0.1,0.4,0.2,0.9,0.4,1.3 l-0.6-0.4c-0.1-0.2-0.2-0.7-0.3-1.1c-0.2-0.9-0.5-1.4-1.1-1.7l-0.1-0.1l0,2l-0.6-0.4l0-4.5L197.4,171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M202.5,174.2l0,0.7l-1.1-0.6l0,3.9l-0.6-0.4l0-3.9l-1.1-0.6l0-0.7L202.5,174.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M203.7,174.8l0,1.5c0.1,0,0.3,0.1,0.6,0.3c0.7,0.4,1.5,1.3,1.4,2.4c0,0.5-0.1,0.7-0.4,0.8 c-0.4,0.2-0.9,0-1.4-0.3c-0.3-0.2-0.7-0.4-0.9-0.6l0-4.5L203.7,174.8z M203.6,178.8c0.1,0.1,0.3,0.2,0.4,0.3 c0.5,0.3,1,0.3,1-0.4c0-0.7-0.5-1.2-0.9-1.5c-0.2-0.1-0.3-0.2-0.5-0.2L203.6,178.8z M206.7,176.6l0,4.5l-0.6-0.4l0-4.5 L206.7,176.6z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M221.7,179.3l1.3,0.8l-0.1,13.5l-2.8-1.6c-1-0.6-1.8-1.4-2.3-2.6c-0.6-1.2-0.9-2.5-0.9-3.8 c0-1.3,0.3-2.2,0.9-2.7s1.4-0.4,2.4,0.1c0.4,0.3,0.9,0.7,1.4,1.2L221.7,179.3z M221.6,191.3l0-5.6c-0.4-0.5-0.8-0.9-1.2-1.1 c-0.7-0.4-1.2-0.4-1.6-0.1c-0.4,0.3-0.6,1-0.6,2c0,0.9,0.2,1.7,0.5,2.4c0.2,0.4,0.4,0.7,0.6,1c0.2,0.2,0.6,0.5,1.2,0.9 L221.6,191.3L221.6,191.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M223.4,180.3l1.4,0.8l-0.1,11.7l4.5,2.7l0,1.8l-6-3.5L223.4,180.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutChat);
export default __webpack_public_path__ + "static/media/about-chat.033edee3e6f929e4087aedce6ddfb99c.svg";
export { ForwardRef as ReactComponent };